import React from 'react';
import { PageTransition } from '../components/PageTransition';
export function PrivacyPolicyPage() {
  return <PageTransition data-id="element-643">
      <div className="pt-32 pb-24 min-h-screen bg-dark-700" data-id="element-644">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-645">
          <div className="mb-12" data-id="element-646">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-647">
              Privacy Policy
            </h1>
            <div className="w-24 h-1 bg-gold-500 rounded-full mb-6" data-id="element-648"></div>
            <p className="text-white/60" data-id="element-649">Last updated: March 2026</p>
          </div>

          <div className="prose prose-invert prose-gold max-w-none space-y-8 text-white/80" data-id="element-650">
            <section data-id="element-651">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-652">
                1. Our Commitment to Your Privacy
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-653">
                At 3 Doves Podcast, we deeply value the trust you place in us.
                Whether you are a listener, a guest, a donor, or a volunteer,
                your privacy is of the utmost importance to our ministry.
              </p>
              <div className="bg-dark-600 border-l-4 border-gold-500 p-6 rounded-r-lg my-6" data-id="element-654">
                <p className="text-white font-medium text-lg m-0" data-id="element-655">
                  We do not sell anyone's information. Any emails or calls are
                  not sold. All volunteer information is strictly confidential
                  and is not sold to any third parties.
                </p>
              </div>
            </section>

            <section data-id="element-656">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-657">
                2. Information We Collect
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-658">
                We only collect information that you voluntarily provide to us,
                which may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-659">
                <li data-id="element-660">
                  Name and contact information (such as email address and phone
                  number) when you reach out to us, subscribe to updates, or
                  volunteer.
                </li>
                <li data-id="element-661">
                  Donation information when you choose to financially support
                  our mission.
                </li>
                <li data-id="element-662">Communication records when you call or email our team.</li>
              </ul>
            </section>

            <section data-id="element-663">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-664">
                3. How We Use Your Information
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-665">
                The information we collect is used solely for the purpose of
                fulfilling our mission and serving you better. This includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-666">
                <li data-id="element-667">
                  Sending you podcast updates, newsletters, and ministry
                  announcements (only if you have opted in).
                </li>
                <li data-id="element-668">Coordinating volunteer efforts and outreach programs.</li>
                <li data-id="element-669">Processing donations and providing tax receipts.</li>
                <li data-id="element-670">
                  Responding to your inquiries, prayer requests, or feedback.
                </li>
              </ul>
            </section>

            <section data-id="element-671">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-672">
                4. Data Security
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-673">
                We implement appropriate technical and organizational security
                measures to protect your personal information against
                unauthorized access, alteration, disclosure, or destruction. We
                treat your personal stories, contact details, and volunteer data
                with the highest level of respect and security.
              </p>
            </section>

            <section data-id="element-674">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-675">
                5. Third-Party Services
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-676">
                We may use trusted third-party services (such as secure payment
                processors or email delivery systems) to help operate our
                ministry. These services only have access to the information
                necessary to perform their specific tasks and are obligated not
                to disclose or use it for any other purpose.
              </p>
            </section>

            <section data-id="element-677">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-678">
                6. Contact Us
              </h2>
              <p className="leading-relaxed" data-id="element-679">
                If you have any questions about this Privacy Policy or how we
                handle your information, please contact us. We are always happy
                to provide clarity and ensure you feel secure in your
                interactions with 3 Doves Podcast.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageTransition>;
}